module.exports = __webpack_public_path__ + "img/fenxiangcopy.137e5df6.png";